import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  cardWrapper: {
    //width: '100%',
    padding: '20px',
    backgroundColor: '#1e1e25',
    color: '#FFFFFF',
    cursor: 'pointer',
    minHeight: '250px',
    '&:hover': {
      transform: 'scale(1.01)'
    }
  },
  stackTitle: {
    fontSize: '2em',
    lineHeight: 1.1,
    marginTop: 15,
  },
  iconImg: {
    height: 30,
    objectFit: 'cover',
  },
}));

export default useStyles